<template lang="html">
  <div class="container">
    <form @submit='handleSubmit'>

      <label for="artist">Name of the artist</label>
      <input
        class="u-full-width"
        type="text"
        placeholder="Guernica"
        v-model="artist"

        required
        />

      <label for="title">Title of the artwork</label>
      <input
        class="u-full-width"
        type="text"
        placeholder="Guernica"
        v-model="title"

        required
        />

      <label for="description">Description</label>
      <textarea
        class="u-full-width"
        placeholder="Description …"
        v-model="description"

        >
      </textarea>


      <label for="year">Year</label>
      <input
        class="u-full-width"
        type="number"
        placeholder="2018"
        v-model="year"

        />

      <fieldset class="row">
        <div class="one-half column">
          <label for="width">Width</label>
          <input
            type="number"
            placeholder="100"
            v-model="width"

            />
        </div>
        <div class="one-half column">
          <label for="height">Height</label>
          <input
            type="number"
            placeholder="100"
            v-model="height"

            />
        </div>
      </fieldset>

      <label for="sku">sku</label>
      <input
        class="u-full-width"
        type="text"
        placeholder="1/10"
        v-model="sku"

        />

      <label for="medium">medium</label>
      <input
        class="u-full-width"
        type="text"
        placeholder="1/10"
        v-model="medium"

        />

      <label for="location">location</label>
      <input
        class="u-full-width"
        type="text"
        placeholder="1/10"
        v-model="location"

        />


      <ImageUpload
        v-if="!image"
        :uploadImage='handleUploadImage'
      />

      <div class="" v-if="image">
        <img :src="`/api/files/${image}`" alt="">
        <button type="button"
          name="button"
          @click='deleteImage'
        >
          Delete image
        </button>
      </div>


      <button class="button-primary" type="submit">
        Save
      </button>
    </form>

  </div>
</template>

<script>
import ImageUpload from './ImageUpload.vue'
import { mapFields } from 'vuex-map-fields'

export default {
  methods : {
    handleSubmit(e) {
      e.preventDefault()
      this.$store.dispatch('savePost', {
        'postId' : this.id
      })
    },
    handleUploadImage() {
      if(this.id) {
        this.$store.dispatch('savePost', { 'postId' : this.id })
      }
    },
    deleteImage() {
      this.$store.dispatch('deleteImage', this.image)
    }
  },
  computed: {
    ...mapFields([
      'currentPost.id',
      'currentPost.artist',
      'currentPost.title',
      'currentPost.description',
      'currentPost.year',
      'currentPost.width',
      'currentPost.height',
      'currentPost.sku',
      'currentPost.medium',
      'currentPost.location',
      'currentPost.image'
    ])
  },
  components : {
    ImageUpload
  }
}
</script>

<style lang="css" scoped>

input[type="email"],
input[type="number"],
input[type="search"],
input[type="text"],
input[type="tel"],
input[type="url"],
input[type="password"],
textarea,
select {
  height: 38px;
  padding: 6px 10px; /* The 6px vertically centers text on FF, ignored by Webkit */
  background-color: #fff;
  border: 1px solid #D1D1D1;
  border-radius: 4px;
  box-shadow: none;
  box-sizing: border-box; }
/* Removes awkward default styles on some inputs for iOS */
input[type="email"],
input[type="number"],
input[type="search"],
input[type="text"],
input[type="tel"],
input[type="url"],
input[type="password"],
textarea {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none; }
textarea {
  min-height: 65px;
  padding-top: 6px;
  padding-bottom: 6px; }
input[type="email"]:focus,
input[type="number"]:focus,
input[type="search"]:focus,
input[type="text"]:focus,
input[type="tel"]:focus,
input[type="url"]:focus,
input[type="password"]:focus,
textarea:focus,
select:focus {
  border: 1px solid #33C3F0;
  outline: 0; }
label,
legend {
  display: block;
  margin-bottom: .5rem;
  font-weight: 600; }
fieldset {
  padding: 0;
  border-width: 0; }
input[type="checkbox"],
input[type="radio"] {
  display: inline; }
label > .label-body {
  display: inline-block;
  margin-left: .5rem;
  font-weight: normal; }


</style>
